<template>
  <div class="menu">
    <h1 v-bind:class="{ 'black': this.black, 'white': !this.black }">888zoeker.nl</h1>

    <div class="menu__filters">
      <h2>PERIODE</h2>
      <!--<span class="timeperiod__selector">MONTH AND YEAR/SPECIFIC DATES</span>-->
      <vue-slider
        ref="slider"
        v-bind="settings"
        v-model="settings.value"
        @drag-start="setActive(true)"
        @drag-end="setActive(false)"
        @callback="dateFormatter(this)"/>
      <div id="menu__filtersPeriod" v-bind:class="{ bgActive: staticSettings.active }">
        <span v-bind:class="{ 'time__left black_bg': this.black, 'time__left white_bg': !this.black }">
          {{staticSettings.minFormatted}}
        </span>
        <span v-bind:class="{ 'time__right black_bg': this.black, 'time__right white_bg': !this.black }">
          {{staticSettings.maxFormatted}}
        </span>
      </div>

      <div class="menu__showfilter">
        <span class="heading" v-bind:class="{ 'heading--active': broadcaster }" @click="selectBroadcaster(true)">OMROEPEN</span>
        <span class="heading">/</span>
        <span class="heading" v-bind:class="{ 'heading--active': !broadcaster }" @click="selectBroadcaster(false)">PROGRAMMA'S</span>
      </div>
      <!-- Broadcasters -->
      <span 
        v-if="showBroadcaster"
        v-for="broadcaster in initialBroadcasters" 
        :key="broadcaster"
        >
        <input type="checkbox" :id="broadcaster" :value="broadcaster" v-model="broadcasters">
        <label :for="broadcaster">{{broadcaster}}</label><br>
      </span>
      <div 
        v-if="showBroadcaster"
        class="select">
        <span @click="selectAll('broadcasters', true)" class="selectall">select all</span>
        <span @click="selectAll('broadcasters', false)" class="selectall">/deselect all</span>
      </div>

      <!-- Programs -->
      <span 
        v-if="!broadcaster"
        v-for="program in initialPrograms" 
        :key="program">
        <input type="checkbox" :id="program" :value="program" v-model="programs">
        <label :for="program">{{program}}</label><br>
      </span>
      <div 
        v-if="!broadcaster"
        class="select">
        <span @click="selectAll('programs', true)" class="selectall">select all</span>
        <span @click="selectAll('programs', false)" class="selectall">/deselect all</span>
      </div>

    </div>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'
import broadcasters from './data/broadcasters.json'
import programs from './data/programs.json'

export default {
  name: 'Menu',
  data () {
    return {
      initialPrograms: programs.programs,
      initialBroadcasters: broadcasters.broadcasters,
      programs: programs.programs,
      broadcasters: broadcasters.broadcasters,
      broadcaster: true,
      showBroadcaster: true,
      staticSettings: {
        active: false,
        minFormatted: '1.2011',
        maxFormatted: '1.2018'
      }
    }
  },
  watch: {
    broadcaster: function() {
      this.$emit('changeBroadcasterBool', this.broadcaster)
    },
    broadcasters: function () {
      this.$emit('changeBroadcaster', this.broadcasters)
    },    
    programs: function () {
      this.$emit('changeProgram', this.programs)
    }
  },
  computed: {
    settings () {
      return {
        value: [this.begin, this.end],
        min: 1262304000,
        max: Date.now()/1000,
        interval: 86400,
        tooltip: false,
        bgStyle: {
          backgroundColor: '#484848'
        },
        processStyle: {
          backgroundColor: '#FF6767'
        }
      }
    }
  },
  beforeUpdate: function () {
    this.dateFormatter()
    // this.$emit('giveTime', this.settings.value)
  },
  props: ['begin', 'end', 'black'],
  components: {
    vueSlider
  },
  mounted: function () {
    this.dateFormatter()
  },
  methods: {
    selectBroadcaster: function (bool) {
      this.broadcaster = bool;
      this.showBroadcaster = bool; // Fix this, apparently have to make another bool to make the if else work
    },
    selectAll: function (type, bool) {
      if (type === 'programs' && bool === true) {
        this.programs = this.initialPrograms
      } else if (type === 'programs' && bool === false) {
        this.programs = []
      } else if (type === 'broadcasters' && bool === true) {
        this.broadcasters = this.initialBroadcasters       
      } else if (type === 'broadcasters' && bool === false) {
        this.broadcasters = []
      }
    },
    dateFormatter: function () {
      var dateObjLow = new Date(this.settings.value[0] * 1000)
      var dateObjHigh = new Date(this.settings.value[1] * 1000)
      this.staticSettings.minFormatted = dateObjLow.getUTCMonth() + 1 + '.' + dateObjLow.getUTCFullYear()
      this.staticSettings.maxFormatted = dateObjHigh.getUTCMonth() + 1 + '.' + dateObjHigh.getUTCFullYear()
    },
    setActive: function (bool) {
      this.staticSettings.active = bool

      if (bool === false) {
        this.$emit('giveTime', this.settings.value)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-family: 'fl-mono', 'Arial';
  color: #FFF;
  font-size: 13px;
  padding-left: 10%;
  margin: 0;
}

.white {
  color: #707070 !important;
}

h2, .timeperiod__selector, .heading {
  font-family: 'fl-mono';
  color: #707070;
  font-size: 13px;
  clear: both;
  margin-bottom: 5px !important;
  font-weight: bold;
}

.heading {
  cursor: pointer;
  color: #484848;

}

.heading--active {
  border-bottom: 2px solid #707070;
  color: #707070;
}

.timeperiod__selector {
  display: block;
  margin-bottom: 20px;
}

.menu {
  width: 20%;
  border-right: 1px solid #707070;
  height: 100%;
  float: left;
  position: fixed;
  z-index: 10;
  padding-top: 61px;
  overflow-x: scroll;

}

.menu__filters{
  padding: 52px 10% 0 10%;
}

.menu__showfilter {
  margin-top: 20px;
  margin-bottom: 10px;
}

#menu__filtersPeriod {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

@keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.bgActive {
  background-image: url('../assets/line.svg');
  background-size: 100% 60%;
  background-position: center 2px;
  background-repeat: no-repeat;
  animation: fadein 1s;
}

.time__left {
  color: #707070;
  font-family: 'fl-mono';
  font-size: 11px;
  margin-top: 2px !important;
  background: black;
}

.time__right {
  color: #707070;
  font-family: 'fl-mono';
  font-size: 11px;
  margin-top: 2px !important;
  background: black;
}

label, span {
  font-family: 'fl-mono';
  color: #707070;
  font-size: .928571429rem;
  margin-top: 6px;
  margin-left: -2px;
}

.select {
  margin-bottom: 150px;
  display: block;
}

.selectall {
  margin-top: 10px;
  display: block;
  float: left;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue